const dynamoConfig = {
  region: "us-east-1",
  identityPoolId: "us-east-1:eb7838e8-57b5-44e0-8ac6-4ff635f856d0",
  dynamoVersion: "2012-08-10",
};
export default dynamoConfig;
